// Angular
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';

// Services
import { ApiService } from '../api/api.service';

@Injectable()
export class SignupService {
    private readonly url = 'https://soledadopinions.servidorbeta.com/salesforce/candidate/add';
    token = localStorage.getItem('tokenOpinions');

    constructor(private api: ApiService) {}

    createCandidate(data: {
        company_name: string;
        company_fiscal_name: string;
        company_cif: string;
        lead_name: string;
        lead_lastname: string;
        lead_address: string;
        lead_postal_code: string;
        lead_city: string;
        lead_province: string;
        lead_email: string;
        lead_phone: string;
        accept_gdpr: string;
        accept_product_offers: string;
        country_iso?: string;
    }) {
        let params = new HttpParams();

        Object.keys(data).forEach((key) => {
            params = params.set(key, data[key] ?? '');
        });

        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded',
                Accept: 'application/json',
                'X-Authorization-Token': this.token
            })
        };

        return this.api.post(this.url, params.toString(), options);
    }
}
